<template>
  <v-simple-table
    dense
    class="monthly-pl-table"
  >
    <thead>
      <tr>
        <th class="sticky-col text-left">
          日付
        </th>
        <th class="text-right">
          現金
        </th>
        <th class="text-right">
          カード
        </th>
        <th class="text-right">
          売掛
        </th>
        <th class="text-right">
          その他収入
        </th>
        <th class="text-right col-income">
          収入計
        </th>
        <th class="text-right">
          キャスト給料
        </th>
        <th class="text-right">
          スタッフ給料
        </th>
        <th class="text-right">
          アライアンス給料
        </th>
        <th class="text-right">
          その他経費
        </th>
        <th class="text-right col-spending">
          支出計
        </th>
        <th class="text-right col-profit">
          利益
        </th>
      </tr>
    </thead>
    <tbody>
      <tr class="total-row font-weight-bold">
        <td class="sticky-col">
          合計
        </td>
        <td class="text-right">
          {{ formatMoney(totals.cashAmount) }}
        </td>
        <td class="text-right">
          {{ formatMoney(totals.cardAmount) }}
        </td>
        <td class="text-right">
          {{ formatMoney(totals.balanceReceivableAmount) }}
        </td>
        <td class="text-right">
          {{ formatMoney(totals.benefitAmount) }}
        </td>
        <td class="text-right">
          {{ formatMoney(totals.income) }}
        </td>
        <td class="text-right">
          {{ formatMoney(totals.castEarningAmount) }}
        </td>
        <td class="text-right">
          {{ formatMoney(totals.waiterEarningAmount) }}
        </td>
        <td class="text-right">
          {{ formatMoney(totals.allianceEarningAmount) }}
        </td>
        <td class="text-right">
          {{ formatMoney(totals.expenseAmount) }}
        </td>
        <td class="text-right">
          {{ formatMoney(totals.spending) }}
        </td>
        <td class="text-right">
          {{ formatMoney(totals.profit) }}
        </td>
      </tr>
      <tr
        v-for="row in rows"
        :key="row.date"
      >
        <td class="sticky-col">
          {{ row.date }}
        </td>
        <td class="text-right">
          {{ formatMoney(row.cashAmount) }}
        </td>
        <td class="text-right">
          {{ formatMoney(row.cardAmount) }}
        </td>
        <td class="text-right">
          {{ formatMoney(row.balanceReceivableAmount) }}
        </td>
        <td class="text-right">
          {{ formatMoney(row.benefitAmount) }}
        </td>
        <td class="text-right col-income font-weight-medium">
          {{ formatMoney(row.income) }}
        </td>
        <td class="text-right">
          {{ formatMoney(row.castEarningAmount) }}
        </td>
        <td class="text-right">
          {{ formatMoney(row.waiterEarningAmount) }}
        </td>
        <td class="text-right">
          {{ formatMoney(row.allianceEarningAmount) }}
        </td>
        <td class="text-right">
          {{ formatMoney(row.expenseAmount) }}
        </td>
        <td class="text-right col-spending font-weight-medium">
          {{ formatMoney(row.spending) }}
        </td>
        <td
          class="text-right font-weight-medium"
          :class="signedClass(row.profit)"
        >
          {{ formatMoney(row.profit) }}
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
export default {
  name: 'AccrualTable',
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    totals: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    formatMoney(amount) {
      if (amount == null || Number(amount) === 0) return '-'

      return `¥${Number(amount).toLocaleString()}`
    },
    signedClass(amount) {
      if (amount == null || Number(amount) === 0) return ''

      return Number(amount) > 0 ? 'col-positive' : 'col-negative'
    },
  },
}
</script>

<style lang="scss" scoped>
.monthly-pl-table {
  // 意味色（$color-pack: false のため独自クラスで指定）
  ::v-deep .col-income {
    color: #1565c0 !important;
  }

  ::v-deep .col-spending {
    color: #c62828 !important;
  }

  ::v-deep .col-profit {
    color: #2e7d32 !important;
  }

  ::v-deep .col-positive {
    color: #2e7d32 !important;
  }

  ::v-deep .col-negative {
    color: #c62828 !important;
  }

  // 日付列を固定して横スクロール
  ::v-deep .sticky-col {
    position: sticky;
    left: 0;
    z-index: 2;
    background: #fff;
  }

  ::v-deep thead .sticky-col {
    z-index: 3;
  }

  ::v-deep .total-row {
    background-color: #f5f5f5;

    .sticky-col {
      background: #f5f5f5;
    }
  }

  // ダークテーマ: 固定列・合計行の背景をテーマ追従させ、意味色は視認できる明色に
  &.theme--dark {
    ::v-deep .sticky-col {
      background: #1e1e1e;
    }

    ::v-deep .total-row {
      background-color: #272727;

      .sticky-col {
        background: #272727;
      }
    }

    ::v-deep .col-income {
      color: #64b5f6 !important;
    }

    ::v-deep .col-spending,
    ::v-deep .col-negative {
      color: #e57373 !important;
    }

    ::v-deep .col-profit,
    ::v-deep .col-positive {
      color: #81c784 !important;
    }
  }
}
</style>
